/* eslint-disable import/prefer-default-export */
export const AMPM_OPTIONS = [
  { label: 'AM', value: 'AM' },
  { label: 'PM', value: 'PM' }
];
